import { render, staticRenderFns } from "./GordijnenManLogo.vue?vue&type=template&id=446ca5c0&scoped=true&"
import script from "./GordijnenManLogo.vue?vue&type=script&lang=js&"
export * from "./GordijnenManLogo.vue?vue&type=script&lang=js&"
import style0 from "./GordijnenManLogo.vue?vue&type=style&index=0&id=446ca5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ca5c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/wouter/apps/go02/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
